import { render, staticRenderFns } from "./orderItem.vue?vue&type=template&id=1249be2e&scoped=true&"
import script from "./orderItem.vue?vue&type=script&lang=js&"
export * from "./orderItem.vue?vue&type=script&lang=js&"
import style0 from "./orderItem.vue?vue&type=style&index=0&id=1249be2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1249be2e",
  null
  
)

export default component.exports